import React, { Component } from 'react';
import { Grid, Row, Col, Table, FormGroup, FormControl } from 'react-bootstrap';
import Select from "react-select";

import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { MarginStyleFormatHelper } from '../helpers/MarginStyleFormatHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { TableButton } from '../../TableButton';

export class MarginStyles extends Component {
    constructor(props) {
        super(props);

        this.nextInternalId = 1;
        this.updatingStyle = false;

        this.state = {
            formStyles: {
                target: null,
                left: null,
                right: null,
                top: null,
                bottom: null
            },
            formData: {
                id: 0,
                internalId: 0,
                target: this.props.targets.data[0],
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            table: {
                data: this.props.data.map(style => Object.assign({ internalId: this.nextInternalId++ }, style)),
                page: 1,
                elementsPerPage: 50
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    // -----------------------

    componentWillReceiveProps(nextProps) {
        const { targets } = nextProps;

        if (!this.updatingStyle) {
            const { formData } = this.state;

            formData.target = targets.data[0];
            this.setState({
                formData: formData
            });
        }

        this.updatingStyle = false;
    }

    // -----------------------

    removeUnunecessaryProperties(style) {
        const modifiedStyle = Object.assign({}, style);
        delete modifiedStyle.internalId;
        return modifiedStyle;
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    // -----------------------

    onChangeValue(e, target) {
        const { formData } = this.state;
        formData[target] = e.target.value;

        this.setState({
            formData: formData
        });
    }

    onSelectValue(e, target) {
        const { formData } = this.state;

        formData[target] = null === e ? "" : e;

        this.setState({
            formData: formData
        });
    }

    // -----------------------

    onSaveStyle(style) {
        let formStyles = {
            target: null,
            left: null,
            right: null,
            top: null,
            bottom: null
        }
        
        if (0 >= style.target.length) {
            formStyles.target = "error"
        }
        if (0 >= style.left.length) {
            formStyles.left = "error"
        }
        if (0 >= style.right.length) {
            formStyles.right = "error"
        }
        if (0 >= style.top.length) {
            formStyles.top = "error"
        }
        if (0 >= style.bottom.length) {
            formStyles.bottom = "error"
        }
        
        this.setState({
            formStyles: formStyles
        });
        
        if (null === formStyles.target && null === formStyles.left && null === formStyles.right && null === formStyles.top && null === formStyles.bottom) {
            this.updateStyles(style);
        }
    }

    updateStyles(style) {
        const { targets } = this.props;
        const { table } = this.state;

        this.updatingStyle = true;

        if (0 === style.internalId) {
            const newStyle = Object.assign({}, style);
            newStyle.internalId = this.nextInternalId++;
            table.data.push(newStyle);
        }
        else {
            const unmodifiedStyle = table.data.filter(function (s) {
                return s.internalId === style.internalId;
            })[0];

            Object.assign(unmodifiedStyle, style);
        }

        this.props.onUpdateMargins(table.data.map(d => Object.assign({}, this.removeUnunecessaryProperties(d))));

        this.setState({
            table: table,
            formData: {
                id: 0,
                internalId: 0,
                target: targets.data[0],
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        });
    }

    onEditStyle(style) {
        this.setState({
            formData: Object.assign({}, style)
        });
    }

    onCancelEditStyle() {
        const { targets } = this.props;

        this.setState({
            formData: {
                id: 0,
                internalId: 0,
                target: targets.data[0],
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        });
    }

    onDeleteStyle(style) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a margem para o elemento "${MarginStyleFormatHelper.getTargetText(style.target)}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    styleInternalId: style.internalId
                }
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { table } = this.state;

        if (isToExecute) {
            table.data = table.data.filter(function (style) {
                return style.internalId !== argument.styleInternalId;
            });

            this.props.onUpdateMargins(table.data.map(d => Object.assign({}, this.removeUnunecessaryProperties(d))));
        }

        this.setState({
            table: table,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // -----------------------

    renderFormButtons(formData) {
        let formButtons = null;
        if (0 === formData.internalId) {
            formButtons = (
                <td colSpan={2}><TableButton icon="icon-plus" title="Adicionar" onClick={() => this.onSaveStyle(formData)} /></td>
            )
        }
        else {
            formButtons = [];
            formButtons.push((
                <td key="formSaveButton"><TableButton icon="icon-save" title="Guardar" onClick={() => this.onSaveStyle(formData)} /></td>
            ));
            formButtons.push((
                <td key="formCancelButton"><TableButton icon="icon-error" title="Cancelar" onClick={() => this.onCancelEditStyle()} /></td>
            ));
        }

        return formButtons;
    }

    render() {
        const { isLoadingTargets, targets } = this.props;
        const { table } = this.state;

        if (isLoadingTargets) {
            return (
                <LoadingSpinner />
            );
        }

        const { formData, formStyles, message, dialog } = this.state;
        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col md={12} className="styles-table">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th>Elemento</th>
                                        <th className="width-10p">Esquerda</th>
                                        <th className="width-10p">Direita</th>
                                        <th className="width-10p">Superior</th>
                                        <th className="width-10p">Inferior</th>
                                        <th className="width-1p">&nbsp;</th>
                                        <th className="width-1p">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        partialData.map((obj, idx) =>
                                            <tr key={`data-${idx}`}>
                                                <td>{MarginStyleFormatHelper.getTargetText(obj.target)}</td>
                                                <td>{obj.left}</td>
                                                <td>{obj.right}</td>
                                                <td>{obj.top}</td>
                                                <td>{obj.bottom}</td>
                                                <td><TableButton icon="icon-edit" title="Editar" onClick={() => this.onEditStyle(obj)} /></td>
                                                <td><TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteStyle(obj)} /></td>
                                            </tr>
                                        )
                                    }

                                    <tr>
                                        <td>
                                            <FormGroup
                                                bsSize="small"
                                                controlId="formTargetSelect"
                                                className="no-margin"
                                                validationState={formStyles.target}>
                                                <Select
                                                    className="custom-multiselect custom-multiselect-small"
                                                    placeholder="Elemento"
                                                    noOptionsMessage={() => "Sem Elementos Configurados"}
                                                    onChange={(e) => this.onSelectValue(e, "target")}
                                                    options={targets.data}
                                                    isMulti={false}
                                                    isClearable={true}
                                                    maxMenuHeight={200}
                                                    isOptionSelected={function (a) {
                                                        return formData.target === a;
                                                    }}
                                                    getOptionValue={value => value}
                                                    getOptionLabel={label => MarginStyleFormatHelper.getTargetText(label)}
                                                    value={[formData.target]}
                                                />
                                            </ FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup
                                                bsSize="small"
                                                controlId="formLeftMarginNumber"
                                                className="no-margin"
                                                validationState={formStyles.left} >
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Esquerda"
                                                    value={formData.left}
                                                    onChange={(e) => this.onChangeValue(e, 'left')} />
                                            </ FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup
                                                bsSize="small"
                                                controlId="formRightMarginNumber"
                                                className="no-margin"
                                                validationState={formStyles.right} >
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Direita"
                                                    value={formData.right}
                                                    onChange={(e) => this.onChangeValue(e, 'right')} />
                                            </ FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup
                                                bsSize="small"
                                                controlId="formTopMarginNumber"
                                                className="no-margin"
                                                validationState={formStyles.top} >
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Superior"
                                                    value={formData.top}
                                                    onChange={(e) => this.onChangeValue(e, 'top')} />
                                            </ FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup
                                                bsSize="small"
                                                controlId="formBottomMarginNumber"
                                                className="no-margin"
                                                validationState={formStyles.bottom} >
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Inferior"
                                                    value={formData.bottom}
                                                    onChange={(e) => this.onChangeValue(e, 'bottom')} />
                                            </ FormGroup>
                                        </td>

                                        {this.renderFormButtons(formData)}
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PaginationBuilder
                                currentPage={table.page}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={table.data.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                        </Col>
                    </Row>
                </Grid>
                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.onExitMessage()} />
                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
